import { render, staticRenderFns } from "./CreateSubject.vue?vue&type=template&id=173f3de9&scoped=true"
import script from "./CreateSubject.vue?vue&type=script&lang=js"
export * from "./CreateSubject.vue?vue&type=script&lang=js"
import style0 from "./CreateSubject.vue?vue&type=style&index=0&id=173f3de9&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173f3de9",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('173f3de9')) {
      api.createRecord('173f3de9', component.options)
    } else {
      api.reload('173f3de9', component.options)
    }
    module.hot.accept("./CreateSubject.vue?vue&type=template&id=173f3de9&scoped=true", function () {
      api.rerender('173f3de9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/employee/CreateSubject.vue"
export default component.exports